import React, { useState } from 'react';
import CountUp from "react-countup";
import { Card, CardBody, Col, Row } from 'reactstrap';
import { postureIconChipStyle, postureIconStyle } from "./iconStyles";

const ORANGE_COLORS = {
    primary: '#FF5B00',
    dark: '#e85a28',
    darker: '#d14d1f',
    light: '#ff8c61',
    lighter: '#ffb399',
    subtle: '#fff5f0',
    muted: '#ffe8dd',
};

const MetricTile = ({ label, counter, subtext, icon, color, borderColor, decimals = 0 }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
        <Card 
          className="card-animate" 
          style={{ 
          background: "var(--vz-secondary-bg, #fff)",
          border: "1px solid var(--vz-border-color)",
          borderRadius: "10px",
          transition: 'all 0.3s ease',
          transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
          boxShadow: isHovered ? '0 8px 16px rgba(0,0,0,0.08)' : '0 1px 4px rgba(0,0,0,0.06)',
          cursor: 'pointer',
          minHeight: '140px',
          height: '100%'
        }}
      onMouseEnter={() => setIsHovered(true)} 
      onMouseLeave={() => setIsHovered(false)}
    >
      <CardBody style={{ 
        display: 'flex', 
        flexDirection: 'column',
        height: '100%'
      }}>
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <p className="text-uppercase fw-medium text-muted mb-0" style={{ 
              fontSize: '11px',
              letterSpacing: '0.5px'
            }}>
              {label}
            </p>
          </div>
          <div className="flex-shrink-0" style={postureIconChipStyle(color)}>
            <i className={icon} style={postureIconStyle(color)}></i>
          </div>
        </div>
        <div className="d-flex align-items-end justify-content-between mt-auto pt-3">
          <div>
            <h4 
              className="fs-22 fw-semibold ff-secondary mb-1" 
              style={{ color: color }}
            >
              <CountUp 
                start={0} 
                end={counter} 
                duration={2} 
                separator="," 
                decimals={decimals}
              />
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: '12px' }}>
              {subtext}
            </p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

const Widgets = ({ stats = null }) => {
    // Show loading if stats not yet loaded
    if (!stats) {
        return (
            <Row className="g-3">
                {[1,2,3].map(i => (
                    <Col xl={4} md={6} key={i}>
                        <Card 
                          className="card-animate"
                        style={{
                            background: "var(--vz-secondary-bg, #fff)",
                            border: '1px solid var(--vz-border-color)',
                            borderRadius: '10px',
                            minHeight: '140px'
                          }}
                        >
                            <CardBody className="text-center">
                                <div className="spinner-border text-muted" style={{ color: ORANGE_COLORS.primary }} role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
        );
    }

    // Calculate additional metrics
    const resolutionRate = stats.total_threats > 0 
        ? ((stats.resolved / stats.total_threats) * 100).toFixed(0) 
        : 0;

    const cyptoWidgets = [
        {
            id: 1,
            label: "Total Threats",
            counter: stats.total_threats,
            subtext: `${stats.new_24h} new in last 24h`,
            icon: "ri-shield-line",
            color: ORANGE_COLORS.primary,
            borderColor: 'var(--vz-border-color)'
        },
        {
            id: 2,
            label: "Resolved Threats",
            counter: stats.resolved,
            subtext: `${resolutionRate}% resolution rate`,
            icon: "ri-shield-check-line",
            color: ORANGE_COLORS.dark,
            borderColor: 'var(--vz-border-color)'
        },
        {
            id: 3,
            label: "Active Threats",
            counter: stats.active,
            subtext: `${stats.critical} critical, ${stats.high} high`,
            icon: "ri-alarm-warning-line",
            color: ORANGE_COLORS.darker,
            borderColor: 'var(--vz-border-color)'
        },
    ];
    
    return (
        <>
            {cyptoWidgets.map((item) => (
                <Col xl={4} md={6} sm={6} xs={12} key={item.id}>
                    <MetricTile 
                      label={item.label}
                      counter={item.counter}
                      subtext={item.subtext}
                      icon={item.icon}
                      color={item.color}
                      borderColor={item.borderColor}
                      decimals={item.id === 4 ? 1 : 0}
                    />
                </Col>
            ))}
        </>
    );
};

export default Widgets;
